import { Api } from "api";

export const getUsers = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const name = payload?.name !== undefined ? `&name=${payload.name}` : "";
  const position = payload?.position !== undefined ? `&position=${payload.position}` : "";
  const role = payload?.role !== undefined ? `&role=${payload.role}` : "";
  const department = payload?.department_id !== undefined ? `&department_id=${payload.department_id}` : "";
  const location = payload?.location_id !== undefined ? `&location_id=${payload.location_id}` : "";
  const res = await Api.get(`/get_users/?hash_pw=${hash}${name}${position}${role}${department}${location}`);
  return res.data;
};

export const getUserByManager = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/get_user_by_manager/?hash_pw=${hash}`);
  return res.data;
};

export const addUser = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/add_user/?hash_pw=${hash}`, payload);
  return res.data;
};

export const changeUserData = async (payload: any) => {
  const hash = localStorage.getItem("hash");
  const res = await Api.post(`/change_user_data/?hash_pw=${hash}&user_id=${payload.user_id}`, payload);
  return res.data;
};

export const getUserFilters = async () => {
  const hash = localStorage.getItem("hash");
  const res = await Api.get(`/users/utils/filter-options?hash_pw=${hash}`);
  return res.data;
};
